import React from 'react';
import PropTypes from 'prop-types';
import { isEqual, isEmpty } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';
import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import FilterRange from '../FilterRange/FilterRange.jsx';
import FilterRangeService from '../FilterRange/FilterRangeService/FilterRangeService.js';

import { DEFAULT_STEP, DEFAULT_MIN, DEFAULT_MAX, URL_PARAMETER_MIN, URL_PARAMETER_MAX } from './constants.js';

class ListingFiltersPrice extends React.Component {
    constructor(props) {
        super(props);

        this.handleSelectedValue = this.handleSelectedValue.bind(this);
        this.updateQuery = this.updateQuery.bind(this);

        this.state = FilterRangeService.getInitState({
            metadataCategorie: props.prices,
            URL_PARAMETER_MIN,
            URL_PARAMETER_MAX,
            DEFAULT_MIN,
            DEFAULT_MAX,
            DEFAULT_STEP,
        });
    }

    componentWillReceiveProps(nextProps) {
        const propsExtremeValues = FilterRangeService.getExtremeValues(this.props.prices);
        const nextPropsExtremeValues = FilterRangeService.getExtremeValues(nextProps.prices);

        // Update the state only if the props of extremeValues has changed.
        if (!isEqual(propsExtremeValues, nextPropsExtremeValues) || isEmpty(nextProps.salePriceRange)) {
            const initState = FilterRangeService.getInitState({
                metadataCategorie: nextProps.prices,
                URL_PARAMETER_MIN,
                URL_PARAMETER_MAX,
                DEFAULT_MIN,
                DEFAULT_MAX,
                DEFAULT_STEP,
            });
            this.setState(initState);
        }
    }

    handleSelectedValue(selectedMin, selectedMax) {
        this.setState({
            selectedMin,
            selectedMax,
        });
    }

    updateQuery(selectedMin, selectedMax) {
        this.props.updateVehicleCriteria(
            {
                type: 'CLOSED',
                from: selectedMin,
                to: selectedMax,
            },
            'salePriceRange',
            true
        );
    }

    render() {
        return (
            <FilterRange
                title={LocaleService.t('FILTERS.PRICE.TITLE')}
                extremeMin={this.state.extremeMin}
                extremeMax={this.state.extremeMax}
                defaultMin={this.state.selectedMin}
                defaultMax={this.state.selectedMax}
                step={DEFAULT_STEP}
                labelMin={LocaleService.l(this.state.selectedMin, CurrencyFormats.CURRENCY_0)}
                labelMax={LocaleService.l(this.state.selectedMax, CurrencyFormats.CURRENCY_0)}
                updateQuery={this.updateQuery}
                handleSelectedValue={this.handleSelectedValue}
                isPrice
            />
        );
    }
}

ListingFiltersPrice.defaultProps = {
    prices: [],
    salePriceRange: {},
};

ListingFiltersPrice.propTypes = {
    prices: PropTypes.arrayOf(PropTypes.instanceOf(MetaDataModel)), // eslint-disable-line react/no-unused-prop-types
    salePriceRange: PropTypes.object,
    updateVehicleCriteria: PropTypes.func.isRequired,
};

ListingFiltersPrice.displayName = 'ListingFiltersPrice';

export default ListingFiltersPrice;
